const baseUrl = process.env.REACT_APP_BASE_API_URL;
console.log('baseUrl:', baseUrl)
const constants = {
  appName: "Mahila Money",
  mmLinkedInUrl: "https://in.linkedin.com/company/mahilamoney",
  mmTwitterUrl: "https://twitter.com/mahilamoney",
  mmFbUrl: "https://www.facebook.com/MahilaMoney",
  mmInstagramUrl: "https://www.instagram.com/mahila.money/",
  mmSheroesUrl: "https://sheroes.com/communities/mahila-money/MjU5MQ==",
  mmYoutubeUrl: "https://www.youtube.com/watch?v=CsM3roT4xdo",
  protectPolicyPdf:
    "https://mahilamoney-community.s3.ap-south-1.amazonaws.com/posts/f645628b-6e7e-4411-91ea-f8037e395308MM%20Protect_comprehensive%20doc.pdf",
  mmPlayStoreUrl:
    "https://play.google.com/store/apps/details?id=com.sm.mahilamoney",
  impactStoriesApiUrl: baseUrl + "community/api/v1/op/impact-stories",
};

export default constants;
